import { useEffect } from 'react'
import { createChannelSubscription } from '../realtime/cable'
import { queryClient } from '../store/provider/TanStackProvider'

const medicationOrdersChannel = createChannelSubscription('MedicationOrdersChannel', 'Medication orders')

export const useMedicationOrdersSubscription = (enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return

    medicationOrdersChannel.ensure(() => {
      void queryClient.invalidateQueries({ queryKey: ['medication'] })
      void queryClient.invalidateQueries({ queryKey: ['medication_administration'] })
      void queryClient.invalidateQueries({ queryKey: ['patient_medications'] })
    })

    return () => {
      medicationOrdersChannel.release()
    }
  }, [enabled])
}
